/*eslint-disable lines-around-comment */
import 'foundation-sites/js/foundation.core';
import 'foundation-sites/js/foundation.util.box';
import 'foundation-sites/js/foundation.util.keyboard';
import 'foundation-sites/js/foundation.util.mediaQuery';
import 'foundation-sites/js/foundation.util.motion';
import 'foundation-sites/js/foundation.util.nest';
// import 'foundation-sites/js/foundation.util.timerAndImageLoader';
import 'foundation-sites/js/foundation.util.touch';
import 'foundation-sites/js/foundation.util.triggers';
// import 'foundation-sites/js/foundation.abide';
// import 'foundation-sites/js/foundation.accordion';
// import 'foundation-sites/js/foundation.accordionMenu';
// import 'foundation-sites/js/foundation.drilldown';
// import 'foundation-sites/js/foundation.dropdown';
// import 'foundation-sites/js/foundation.dropdownMenu';
// import 'foundation-sites/js/foundation.equalizer';
// import 'foundation-sites/js/foundation.interchange';
// import 'foundation-sites/js/foundation.magellan';
import 'foundation-sites/js/foundation.offcanvas';
// import 'foundation-sites/js/foundation.orbit';
// import 'foundation-sites/js/foundation.reveal';
// import 'foundation-sites/js/foundation.slider';
// import 'foundation-sites/js/foundation.sticky';
// import 'foundation-sites/js/foundation.tabs';
// import 'foundation-sites/js/foundation.toggler';
// import 'foundation-sites/js/foundation.tooltip';
// import 'foundation-sites/js/foundation.responsiveMenu';
// import 'foundation-sites/js/foundation.responsiveToggle';
/*eslint-enable lines-around-comment */



// WEBPACK FOOTER //
// ./resources/assets/js/_includes/foundation.js